import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import TkDialog from "../../components/atoms/TkDialog";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import TkAmountInput from "../../components/molecules/TkAmountInput";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkCsvUpload from "../../components/molecules/TkCsvUpload";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkFakeTableLine from "../../components/atoms/TkFakeTableLine";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_STA020_Response } from "../../type/apiType";
import { StaffList } from "../../type/apiType/IAPI_STA020";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { changeAmountFormat } from "../../utils/useTools";
import { SexFlug } from "../../assets/data/Constants";
import { TkGetCode } from "../../utils/TkGetCode";
import "./_style.scss";
import { httpAPI_FAC019, httpAPI_STA005, httpAPI_STA020 } from "./api/request";
import {
  facilitySelectList,
  fakeHeadTitleList,
  searchFormList,
  searchFormSchema,
} from "./parts";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import { IJob_32Props } from "../../type/contextType/businessContext/IJob_32";
import { IJob_11Props } from "../../type/contextType/businessContext/IJob_11";
import _ from "lodash";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";

interface CustomType {
  salaryTableAmtDefault?: number;
  salaryTableAmtError?: string;
  salaryAdjustmentAmtDefault?: number;
  salaryAdjustmentAmtError?: string;
}

/**
 * SCRC060116 職員一覧　本俸月額更新
 * @Todo ファイル一括アップロード
 * @return SCRC060116 職員一覧　本俸月額更新
 */
const SCRC060116 = () => {
  const navigate = useNavigate();
  const { state: businessState } = useContext(BusinessContext);
  const { state: globalState, setState } = useContext(GlobalContext);
  const [facilityList, setFacilityList] = useState<any>([]);
  const [selectItem, setSelectItem] = useState<string>("");
  const [bodyInfoList, setBodyInfoList] = useState<any[]>([]);
  const [stateStaffList, setStateStaffList] = useState<
    (CustomType & StaffList)[]
  >([]);
  const [open, setOpen] = useState(false);
  const currentFakeHeadTitleListRef = useRef<any>();
  const [resData, setResData] = useState<IAPI_STA020_Response>({});
  const [selectedFacilityNo, setSelectedFacilityNo] = useState<string>();
  const [openUploadComplete, setOpenUploadComplete] = useState(false);
  const isKiko =
    globalState.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const businessType = businessState.common?.businessType
    ?.toLowerCase()
    .replace("-", "_")!;
  const context = businessState[businessType as keyof typeof businessState] as
    | IJob_11Props
    | IJob_32Props;
  const pageValueRef = useRef(0);
  const notApplicablFacilityNo = "999";
  const [isNo999, setIsNo999] = useState(false);

  const debouncedSetState = useRef(
    _.debounce((newStateUpdater: any) => {
      setStateStaffList(newStateUpdater);
    }, 300)
  ).current;

  useEffect(() => {
    return () => {
      debouncedSetState.cancel();
    };
  }, [debouncedSetState]);

  useEffect(() => {
    setIsNo999(context?.facilityNo === notApplicablFacilityNo);
  }, [context?.facilityNo]);

  async function openingScreen() {
    setResData({ resultCd: "" });
    setBodyInfoList([]);
    setSelectItem("");

    // プルダウン用有効施設一覧参照API 呼び出し
    try {
      const res = await httpAPI_FAC019({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : globalState.authInfo?.contractorNo,
        businessType: businessState.common?.businessType,
      });

      if (res.resultCd === "I0000") {
        let selectList = res.facilityList?.map((item) => {
          return {
            label: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
            value: item.facilityNo,
          };
        });

        setFacilityList(selectList);

        setState({
          ...globalState,
          errorMsgId: "",
        });
      } else {
        setState({
          ...globalState,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  }

  useEffect(() => {
    let bodyList = stateStaffList.map((item: any, index) => [
      {
        children: (item.staffNo ?? "") + ":" + (item.staffNameKanji ?? ""),
        forSort: item.staffNo,
      },
      {
        children: item.birthday,
        forSort: item.birthday,
        align: "center",
      },
      {
        children: TkGetCode(SexFlug, item.sex),
        forSort: item.sex,
        align: "center",
      },
      {
        children: changeAmountFormat(item.monthlySalaryAmt ?? ""),
        forSort: item.monthlySalaryAmt,
        align: "right",
      },
      {
        children: (
          <TkAmountInput
            onChange={(e: any) =>
              handleChangeAmount("salaryTableAmt", e.target.value, index)
            }
            wantToSetValue={item.salaryTableAmtDefault ?? 0}
            inputProps={{ maxLength: 9 }}
            error={!!item.salaryTableAmtError}
            errorMessage={item.salaryTableAmtError}
            disabled={item.loackState !== "0" || isNo999}
          />
        ),
        forSort: item.salaryTableAmt,
      },
      {
        children: (
          <TkAmountInput
            onChange={(e: any) =>
              handleChangeAmount("salaryAdjustmentAmt", e.target.value, index)
            }
            wantToSetValue={item.salaryAdjustmentAmtDefault ?? 0}
            inputProps={{ maxLength: 9 }}
            error={!!item.salaryAdjustmentAmtError}
            errorMessage={item.salaryAdjustmentAmtError}
            disabled={item.loackState !== "0" || isNo999}
          />
        ),
        forSort: item.salaryAdjustmentAmt,
      },
      {
        children: item.updateDate,
        forSort: item.updateDate,
        align: "center",
      },
    ]);

    setBodyInfoList(bodyList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateStaffList]);

  const handleChangeAmount = (
    field: "salaryTableAmt" | "salaryAdjustmentAmt",
    amount: number,
    index: number
  ) => {
    debouncedSetState((prev: any) => {
      return prev.map((d: any, i: any) => {
        if (i === index) {
          switch (field) {
            case "salaryTableAmt":
              d.salaryTableAmt = amount;
              d.salaryTableAmtDefault = amount;
              d.monthlySalaryAmt = (amount ?? 0) + d.salaryAdjustmentAmt;
              d.salaryTableAmtError =
                amount === null || amount === undefined
                  ? TkPropertyMessageGet("TKMSG_SCR0043E")
                  : "";
              break;
            default:
              d.salaryAdjustmentAmt = amount;
              d.salaryAdjustmentAmtDefault = amount;
              d.monthlySalaryAmt = (amount ?? 0) + d.salaryTableAmt;
              d.salaryAdjustmentAmtError =
                amount === null || amount === undefined
                  ? TkPropertyMessageGet("TKMSG_SCR0043E")
                  : "";
          }

          return d;
        }

        return d;
      });
    });
  };

  const chagelLatestUpdateDate = (year?: number) => {
    const currentFakeHeadTitleList = fakeHeadTitleList.forEach((item) => {
      if (item.className === "latestUpdateDate") {
        item.headTitle = (
          <>
            {year ? `${year}年度` : ""}最終更新日
            <TkHelpIcon helpMessage="本俸月額を最後に更新した日です。" />
          </>
        );
      }
    });

    currentFakeHeadTitleListRef.current = currentFakeHeadTitleList;
  };

  const selectFacility = async (value: any, type: "select" | "search") => {
    type === "select" && setSelectItem(value);
    type === "select" && setSelectedFacilityNo(value);

    // 職員一覧本俸月額参照API 呼び出し
    if (value !== "") {
      try {
        const res = await httpAPI_STA020({
          contractorNo: isKiko
            ? businessState.common?.contractorNo
            : globalState.authInfo?.contractorNo,
          facilityNo: type === "select" ? value : selectItem,
          staffNo: context?.staffNo,
          staffName: type === "search" ? value : "",
        });

        if (res.resultCd === "I0000") {
          setResData(res);
          chagelLatestUpdateDate(res.year);

          let staffList: any = res.staffList?.map((item) => {
            return {
              ...item,
              salaryTableAmtDefault: item.salaryTableAmt,
              salaryAdjustmentAmtDefault: item.salaryAdjustmentAmt,
            };
          });
          pageValueRef.current = 0;
          setStateStaffList(staffList);
          setState({
            ...globalState,
            errorMsgId: "",
          });
        } else {
          setState({
            ...globalState,
            errorMsgId: res.resultCd,
          });
          setStateStaffList([]);
        }
      } catch (error) {
        navigate("/error");
      }
    }
  };

  useEffect(() => {
    if (context?.staffNo) {
      setFacilityList([
        {
          label:
            (context?.facilityNo ?? "") +
            ":" +
            (context?.facilityNo === notApplicablFacilityNo
              ? "対象外施設"
              : context?.facilityName ?? ""),
          value: context?.facilityNo,
        },
      ]);
    } else {
      openingScreen();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateClick = () => {
    const errorCheck = stateStaffList.some(
      (item) => item?.salaryAdjustmentAmtError || item?.salaryTableAmtError
    );
    if (errorCheck) return;

    setOpen(true);
  };

  const okClick = async () => {
    setOpen(false);

    if (
      stateStaffList?.some(
        (stateStaff) => (stateStaff?.salaryTableAmt ?? 0) <= 73999
      )
    ) {
      // 俸給表の額 ≦ 73,999円
      setState({
        ...globalState,
        errorMsgId: "TKMSG_SCR0124E",
      });
      return;
    }

    const staffList = stateStaffList.map((item) => {
      return {
        staffNo: item.staffNo,
        year: resData.year,
        monthlySalaryAmt: item.monthlySalaryAmt,
        salaryTableAmt: item.salaryTableAmt,
        salaryAdjustmentAmt: item.salaryAdjustmentAmt,
        updateDateTime: item.updateDateTime,
      };
    });

    // 日々更新法人職員俸給更新API 呼び出し
    try {
      const res = await httpAPI_STA005({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : globalState.authInfo?.contractorNo,
        staffList,
        businessType: businessState.common?.businessType!,
        facilityNo: selectItem,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...globalState,
          errorMsgId: "",
        });
        await openingScreen();
        await selectFacility(selectItem, "select");
      } else {
        setState({
          ...globalState,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // csvファイルアップロード
  const csvUploadSuccess = async (csvData: any) => {
    setSelectedFacilityNo("");
    const makeStaffList = csvData.map((data: any) => {
      return {
        staffNo: data.staffNumber,
        year: parseInt(data.year),
        monthlySalaryAmt:
          parseInt(data.salary) + parseInt(data.salaryAdjustment),
        salaryTableAmt: parseInt(data.salary),
        salaryAdjustmentAmt: parseInt(data.salaryAdjustment),
        updateDateTime: null, // 本俸月額最終更新日
      };
    });

    // 日々更新法人職員俸給更新API 呼び出し
    try {
      const res = await httpAPI_STA005({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : globalState.authInfo?.contractorNo,
        staffList: makeStaffList,
        businessType: businessState.common?.businessType,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...globalState,
          errorMsgId: "",
        });
        setOpenUploadComplete(true);
        selectFacility(selectItem, "select");
      } else {
        setState({
          ...globalState,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSortChange = (sort: any) => {
    if (!sort || sort.length === 0) return;
    const sortedArr = sort.map((item: any) => {
      return item[0].forSort;
    });

    const sortedStaffList = sortedArr
      .map((staffNo: any) =>
        stateStaffList.find((staff) => staff.staffNo === staffNo)
      )
      .filter((staff: any) => staff !== undefined);

    setStateStaffList(sortedStaffList);
  };

  return (
    <Box data-testid="SCRC060116PageForTest" className="tkSCRC060116">
      <TkInfoManual children={labelids.labelid.LBLC060116_01} rule={"\\n"} />
      {globalState.authInfo?.userType ===
        authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="契約者(法人)名"
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}
      <TkFakeTableLine
        {...facilitySelectList}
        selectPropsList={facilityList}
        onChange={(e: any) => selectFacility(e.target.value, "select")}
        disabled={!!context?.staffNo}
        setDefaultValue={
          facilityList?.length
            ? context?.staffNo
              ? context?.facilityNo
              : selectedFacilityNo
            : ""
        }
      />

      {!!selectItem && (
        <Box className="table">
          <TkDataTable
            headList={currentFakeHeadTitleListRef.current ?? fakeHeadTitleList}
            bodyList={bodyInfoList}
            count={bodyInfoList.length}
            defaultRowsPerPage={10}
            setPageValue={pageValueRef.current}
            dontResetPage
            pagin
            showUnit
            headerLeftComponent={
              <TkSearchForm
                listData={searchFormList}
                ruleSchema={searchFormSchema}
                onSearch={(e: any) => selectFacility(e.name, "search")}
              />
            }
            onSortChange={handleSortChange}
            onPageChange={(_, page) => (pageValueRef.current = page - 1)}
          />
        </Box>
      )}

      <Box className="tkBtnArea">
        <TkBackButton />
        {selectItem && (
          <TkButton
            onClick={updateClick}
            disabled={!bodyInfoList?.length || isNo999}
          >
            更新
          </TkButton>
        )}
        {!context?.staffNo && (
          <TkCsvUpload
            buttonName="CSVアップロード更新"
            type="houjinStaffMonthlySalary"
            onSuccess={csvUploadSuccess}
          />
        )}
      </Box>

      <TkDialog
        open={open}
        title="確認(職員の本俸月額を更新します)"
        contextText="　職員の本俸月額を更新します。よろしいですか？"
        okText="はい"
        cancelText="いいえ"
        onCancel={() => setOpen(false)}
        onSave={okClick}
      />
      <TkMessageDialog
        open={openUploadComplete}
        onOky={() => {
          setOpenUploadComplete(false);
        }}
        title="アップロード完了"
        contextText="　アップロードが完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRC060116;
